import { Setting } from '../models';
import {
    buildEmailLayoutPreviewContext,
    setting_to_plain,
} from './emailLayoutPreviewUtils';
import { build_preview_distributor_report } from './distributorReportPreview';
import { PREVIEW_ORDER_PARTS_VARIANT } from './emailOrderPartsPreview';

/**
 * Preview context for a default transactional email layout key.
 * Mirrors EmailLayouts editor context (order parts variant, ticket col label, …).
 *
 * @param {string} layoutKey
 * @param {object} setting
 * @param {string} lang
 * @param {{ ticket_col_label?: string }} [options]
 */
export function buildDefaultLayoutEmailPreviewContext(layoutKey, setting, lang, options = {}) {
    const plain = setting_to_plain(setting);
    const previewSetting = new Setting(plain);
    const { ticket_col_label } = options;

    if (layoutKey === 'distributor_report') {
        const currency = plain?.l10n?.currency || 'CHF';
        const base = buildEmailLayoutPreviewContext({
            setting: previewSetting,
            lang,
            ticket_col_label,
        });
        return {
            ...base,
            distributor_report: build_preview_distributor_report(lang, currency),
        };
    }

    if (layoutKey === 'booking_summary') {
        return buildEmailLayoutPreviewContext({
            setting: previewSetting,
            lang,
            ticket_col_label,
            include_booking_summary: true,
        });
    }

    if (layoutKey === 'order_confirmation') {
        return buildEmailLayoutPreviewContext({
            setting: previewSetting,
            lang,
            ticket_col_label,
            order_parts_variant: PREVIEW_ORDER_PARTS_VARIANT.TICKETS_ONLY,
        });
    }

    return buildEmailLayoutPreviewContext({
        setting: previewSetting,
        lang,
        ticket_col_label,
    });
}
